<!-- Chat Input Card -->
<div class="chat-card" [class.chat-active-card]="isChatMode">
    <!-- Row 1: Attach button + Textarea + Analyze button (when chat active) -->
    <div class="chat-row chat-row-top">
        <label
            class="attach-icon"
            [class.attach-icon-disabled]="disabled"
            for="chat-file-input"
            [attr.title]="'Attach file'">attach_file</label>
        <input 
            id="chat-file-input" 
            type="file" 
            class="hidden-file-input" 
            multiple
            accept=".pdf,.png,.jpg,.jpeg,.gif,.webp,application/pdf,image/*"
            [disabled]="disabled"
            (change)="onFileSelected($event)">
        <label class="sr-only" for="chat-message-input">Prompt</label>
        <textarea
            id="chat-message-input"
            class="chat-text"
            rows="2"
            [placeholder]="promptPlaceholder"
            [attr.aria-label]="promptPlaceholder"
            title="Prompt"
            [value]="promptText"
            (input)="onTextInput($event)"
            (keydown.enter)="onEnterKey($event)"
            (paste)="onPaste($event)"
            [disabled]="disabled"></textarea>
        <!-- Analyze button moves here when chat is active -->
        <button 
            *ngIf="isChatMode"
            class="analyze-button" 
            (click)="onSubmit()"
            [disabled]="disabled">Submit</button>
    </div>

    <!-- Row 2: File chips (if any) -->
    <div class="chat-row file-name-row" *ngIf="selectedFiles.length > 0">
        <span class="file-name-label">Files:</span>
        <div class="file-list">
            <div class="file-chip" *ngFor="let name of selectedFiles; let i = index" [title]="name">
                <span class="file-name-text">{{ name }}</span>
                <button 
                    type="button" 
                    class="file-remove" 
                    aria-label="Remove file" 
                    (click)="removeFile(i)">close</button>
            </div>
        </div>
    </div>

    <!-- Row 3: Generate DRT Table + Analyze button (only when not in chat mode) -->
    <div class="chat-row chat-row-bottom" *ngIf="!isChatMode">
        <button 
            class="analyze-button" 
            (click)="onSubmit()"
            [disabled]="disabled">Submit</button>
    </div>
</div>
